function App() {
  return (
    <div className="flex items-center justify-center h-screen">
      <p className="text-center w-ful">under construction &lt;3</p>
    </div>
  );
}

export default App;
